import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import strings from '../../components/locales/';
import { Tooltip } from 'react-bootstrap';
import toastr from 'toastr';
import $ from 'jquery';
import constant from '../function/constants';

/* Function */
import ObjGeneral from '../function/';
/* Local store */
import { localStoreFN } from '../../store/localStorage';
/* Actions */
import * as flowApplicantActions from '../../actions/flow_applicant_detail/index';
import * as accountDriverActions from '../../actions/account_driver/index';
import * as accountVehicleActions from '../../actions/account_vehicle/index';
import * as accountSemiTrailerActions from '../../actions/account_semi_trailer/index';
import * as dynamicListActions from '../../actions/dynamic_list';

/* Components */
import Title from '../../components/flow_applicant_detail/title';
import Buttons from '../../components/flow_applicant_detail/buttons';
import FlowsTable from '../../components/flow_applicant_detail/flowsTable';
import BottomTableButtons from '../../components/flow_applicant_detail/bottomTableButtons';
import ModalViewComments from '../../components/flow_admin_detail/modalViewComments';
import ModalEdit from '../../components/flow_applicant_detail/modalEdit';
import ModalCreate from '../../components/flow_applicant_detail/modalCreate';
import Loading from '../../components/common/loading';
import Message from '../../components/common/message';
import Expired from '../expired/index';

class FlowApplicantDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModalEdit: false,
      selectedFlow: null,
      showModalCreate: false,
      showModalViewComments: false,
      viewComments: "",
      newFlow: null,
      validateAction: null,
      refreshTime: 60000 * 10, //10min
      refreshIntervalObject: null,
      listsByName: {}
    };
  }

  componentWillUnmount() {
    this.props.actions.reset();
    if(this.state.refreshIntervalObject != null) {
      clearInterval(this.state.refreshIntervalObject);
    }
  }

  async componentDidMount() {
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('flowrequestsapplicant');

    if (permit) {
      if (this.props.setting) {
        const obj = JSON.parse(this.props.setting.value);

        if (obj.generalSetting.views.includes('flowrequests')) {
          await this.props.accountSemiTrailerActions.fetchAccountSemiTrailerExtendedPropertiesApi({});
          await this.props.accountSemiTrailerActions.fetchAccountSemiTrailerApi({            
            see: true
          });
          await this.props.accountDriverActions.fetchAccountDriverApi({            
            see: true
          });
          await this.props.accountVehicleActions.fetchAccountVehicleApi({            
            see: true
          });        
          await this.props.dynamicListActions.getAllListWithItems({});
          await this.props.actions.fetchFlowApplicantDetailApi({});
          this.state.refreshIntervalObject = setInterval(
            (function() {
              if(!this.state.showModalEdit){
                this.props.actions.backgroundFetchFlowApplicantDetailApi({});
              }
            }).bind(this),
            this.state.refreshTime
          );         
        } else {
          this.props.history.push('/dashboard/authorization');
        }
      }
    } else {
      this.props.history.push('/dashboard/authorization');
    }
  }

  //Manage redux state changes
  async componentDidUpdate(prevProps) {
    toastr.options = constant.tostrOptions;
    //map lists by name
    if (prevProps.lists.loading == true 
      && this.props.lists.loading == false
      && this.props.lists.status === 200) {      
      this.props.lists.datos.map((item) => {
        this.state.listsByName[item.name.toUpperCase()] = item;
      });
    }

    //flow validation ok, so, now create or update
    if (prevProps.validateFlow.loading == true 
      && this.props.validateFlow.loading == false
      && this.props.validateFlow.status == 200) {
      if(this.state.validateAction=="create") {
        await this.props.actions.createFlow({flowRequest: this.state.newFlow});
      }
      else if(this.state.validateAction=="update") {
        await this.props.actions.updateFlow({flowRequest: this.state.selectedFlow});
      }
      this.state.validateAction=null;
    }

    //sendFlows manage result behavior
    if (prevProps.sendFlows.loading == true 
      && this.props.sendFlows.loading == false
      && this.props.sendFlows.status === 200) {      
      await this.props.actions.backgroundFetchFlowApplicantDetailApi({});
      toastr.success(
        "Los cambios fueron guardados y enviados con exito.",
        "Información"
      );
    }
    else if (prevProps.sendFlows.loading == true 
      && this.props.sendFlows.loading == false
      && this.props.sendFlows.status !== 200) {      
      toastr.error(
        "Error al guardar cambios. Intentelo nuevamente.",
        "Error"
      );
    }
  }

  clearOverWeightFields = flowRequest => {
    if(flowRequest.vehicleType!="Sobredimensión") {
      flowRequest.mopPermit = "";
      flowRequest.mopPermitFiles = "";
      flowRequest.escort = "";
      delete flowRequest.mopPermitFilesNew;
    }
  };

  handleChangeCreateInput = e => {
    let newFlow = { ...this.state.newFlow };

    if(e.target.type=="file") {
      newFlow[e.target.dataset.update + "New"] = e.target.id;      
      newFlow[e.target.dataset.update] = e.target.value;
    }
    else {
      newFlow[e.target.dataset.update] = e.target.value;
    }

    if(e.target.aliasValue) {
      newFlow[e.target.aliasValue.dataset.update] = e.target.aliasValue.value;
    }

    if(e.target.dataset.update=="vehicleType") {
      this.clearOverWeightFields(newFlow);
      newFlow.time = "";
    }

    this.setState({
      newFlow
    });
  };

  handleClickCreate = e => {
    const newFlow = {comments:""};    
  	
  	this.setState({
  		showModalCreate: true,
  		newFlow: newFlow
  	});
  };

  handleCloseModalCreate = async e => {
    if (e.target.dataset.close == 'ok') {
      this.setState({
        showModalCreate: false,
        newFlow: null,
        validateAction: null
      });

      if(this.props.createFlow.status === 200) {      
        await this.props.actions.backgroundFetchFlowApplicantDetailApi({});
      }
      
      this.props.actions.validateFlowApiReset();  
      this.props.actions.createFlowApiReset(); 
    }
  };

  handleCreateFlow = async e => {
    if(this.state.newFlow) {      
      this.state.validateAction = "create";
      await this.props.actions.validateFlow({flowRequest: this.state.newFlow});
    }
  };

  handleChangeEditInput = e => {
    let selectedFlow = { ...this.state.selectedFlow };

    if(e.target.type=="file") {
      selectedFlow[e.target.dataset.update + "New"] = e.target.id;      
      selectedFlow[e.target.dataset.update] = e.target.value;
    }
    else {
      selectedFlow[e.target.dataset.update] = e.target.value;
    }

    if(e.target.aliasValue) {
      selectedFlow[e.target.aliasValue.dataset.update] = e.target.aliasValue.value;
    }

    if(e.target.dataset.update=="vehicleType") {
      this.clearOverWeightFields(selectedFlow);
      selectedFlow.time = "";
    }
        
    this.setState({
      selectedFlow
    });
  };

  handleClickEdit = e => {
    const modifiedFlow = JSON.parse(e.target.dataset.datos);
  	
  	this.setState({
  		showModalEdit: true,
  		selectedFlow: modifiedFlow
  	});
  };

  handleCloseModalEdit = async e => {
    if (e.target.dataset.close == 'ok') {
      this.setState({
        showModalEdit: false,
        selectedFlow: null,
        validateAction: null
      });

      if(this.props.updateFlow.status === 200) {      
        await this.props.actions.backgroundFetchFlowApplicantDetailApi({});
      }

      this.props.actions.validateFlowApiReset();
      this.props.actions.updateFlowApiReset();      
    }
  };

  handleUpdateFlow = async e => {
    if(this.state.selectedFlow) {
      this.state.validateAction = "update";
      await this.props.actions.validateFlow({flowRequest: this.state.selectedFlow});
    }
  };

  handleClickToggleToSendFlow = e => {
    const toggleFlow = JSON.parse(e.target.dataset.datos);    
    const action = e.target.dataset.action;
    this.props.actions.toogleToSendLater(toggleFlow, action);
  };

  handleSendFlows = async e => {
    var flowsToSendArray = [];
    for (const prop in this.props.flowsToSend) {
      var flowState = null;
      if(this.props.flowsToSend[prop].modifiedFlow) {
        flowState = this.props.flowsToSend[prop].modifiedFlow.flowRequestState;
      }
      
      if(flowState == "Pending" || flowState == "Accepted" || flowState == "Edited") {
        toastr.options = constant.tostrOptions;
        toastr.error(
          "No puedes enviar solicitudes Pendientes, Aceptadas o Editadas (se considera aceptada).",
          "Error"
        );

        return false;
      }

      flowsToSendArray.push(this.props.flowsToSend[prop]);
    }

    if(flowsToSendArray.length==0) {
      toastr.options = constant.tostrOptions;
      toastr.error(
        "Debes seleccionar al menos una solicitud para enviar.",
        "Error"
      );
    }
    else {
      await this.props.actions.sendFlows(flowsToSendArray); 
    }
  };

  handleModalViewComments = e => {
      const comment = JSON.parse(e.target.dataset.datos);
      this.setState({
        showModalViewComments: true,
        viewComments: comment
      });
  };

  handleCloseModalViewComments = e => {
    if (e.target.dataset.close == 'ok') {
      this.setState({
        showModalViewComments: false,
        viewComments: ""
      });
    }
  };

  handleDownloadMopFile = async e => {
    const path = JSON.parse(e.target.dataset.path);
    await this.props.actions.downloadMopFile({
      path: path
    });
  };

  handleGetSemiTrailerType = semiTrailerId => {
    var type = "Desconocido";
    
    if(this.props.accountSemiTrailerDatos &&
      this.props.semiTrailerExtendedProperties) {
      var semiTrailerTypeIdProperty = null;

      this.props.semiTrailerExtendedProperties.map(prop => {
        if(prop.name.toUpperCase()=="TIPO") {
          semiTrailerTypeIdProperty = prop.id;
        }
      });

      this.props.accountSemiTrailerDatos.map(item => {
        if(item.id==semiTrailerId) {
          if(item.extendedProperties) {
            item.extendedProperties.map(property => {
              if(property.id==semiTrailerTypeIdProperty &&
                property.value)
              type = property.value;
            });
          }
        }
      });
    }
    return type;
  };

  render() {
    if (this.props.setting) {
      const obj = JSON.parse(this.props.setting.value);
      const setting = ObjGeneral.getSetting({
        setting: obj.tasksManager,
        filter: this.props.filter,
        general: obj.generalSetting
      });
      const { graphColorRange } = obj;
      const language = this.props.language ? this.props.language : '';
      return (
        <section className="main flow-applicant-detail">
          {(this.props.loading 
            || this.props.accountDriverLoading
            || this.props.accountVehicleLoading
            || this.props.accountSemiTrailerLoading
            || this.props.lists.loading) ? (
            <Loading language={this.props.language} />
          ) : (this.props.status === 401 
          || this.props.accountDriverStatus == 401
          || this.props.accountVehicleStatus == 401
          || this.props.accountSemiTrailerStatus == 401
          || this.props.lists.status == 401) ? (
            <Expired
              history={this.props.history}
              language={this.props.language ? this.props.language : ''}
            />
          ) : (this.props.status === 200 
          && this.props.accountDriverStatus == 200
          && this.props.accountVehicleStatus == 200
          && this.props.accountSemiTrailerStatus == 200
          && this.props.lists.status == 200) ? (
            <div className="main-container scroll">
              <Title language={this.props.language} />
              <Buttons
                handleModal={this.handleClickCreate}
                language={this.props.language ? this.props.language : ''}
              />
              <div className="table-row">
                <FlowsTable
                  data={this.props.datos.flowRequests}
                  flowsToSend={this.props.flowsToSend}
                  handleClickEdit={this.handleClickEdit}
                  handleClickToogleToSend={this.handleClickToggleToSendFlow}
                  handleModalViewComments={this.handleModalViewComments}
                  handleDownloadMopFile={this.handleDownloadMopFile}
                  language={this.props.language}
                />
                {(this.props.backgroundFetch.loading || this.props.sendFlows.loading) ? (
                  <div className="loading_dynamic_list table-loading-over">
                    <div className="lds-roller"><div/><div/><div/><div/><div/><div/><div/><div/></div>
                  </div>
                ):(null)}
              </div>
              <BottomTableButtons
                language={this.props.language}
                className={"bottom-row"}
                handleSendFlows={this.handleSendFlows}
              />
              <ModalEdit
                handleChange={this.handleChangeEditInput}
                handleSubmit={this.handleUpdateFlow}
                handleClose={this.handleCloseModalEdit}
                showModal={this.state.showModalEdit}
                selectedFlow={this.state.selectedFlow}
                validateFlow={this.props.validateFlow}
                updateFlow={this.props.updateFlow}
                language={this.props.language}
                drivers={this.props.accountDriverDatos}
                vehicles={this.props.accountVehicleDatos}
                semiTrailers={this.props.accountSemiTrailerDatos}
                lists={this.state.listsByName}
                getSemiTrailerType={this.handleGetSemiTrailerType}
              />
              <ModalCreate
                handleChange={this.handleChangeCreateInput}
                handleSubmit={this.handleCreateFlow}
                handleClose={this.handleCloseModalCreate}
                showModal={this.state.showModalCreate}
                newFlow={this.state.newFlow}
                validateFlow={this.props.validateFlow}
                createFlow={this.props.createFlow}
                language={this.props.language}
                drivers={this.props.accountDriverDatos}
                vehicles={this.props.accountVehicleDatos}
                semiTrailers={this.props.accountSemiTrailerDatos}
                lists={this.state.listsByName}
                getSemiTrailerType={this.handleGetSemiTrailerType}
              />
              <ModalViewComments
                handleClose={this.handleCloseModalViewComments}
                showModal={this.state.showModalViewComments}
                comments={this.state.viewComments}
                language={this.props.language}
              />
              <Tooltip placement="top" id="pageTooltip" />
            </div>
          ) : this.props.status === 500 
          || this.props.accountDriverStatus === 500
          || this.props.accountVehicleStatus === 500
          || this.props.accountSemiTrailerStatus === 500
          || this.props.lists.status === 500 ? (
            <Message message={this.props.language.error.apiError500} />
          ) : (
            <Message message={this.props.language.error.apiError} />
          )}
        </section>
      );
    } else {
      return (
        <section className="main">
          <Message message="NO Setting" />
        </section>
      );
    }
  }
}
const mapStateToProps = state => ({
  language: state.reducer.dashboard.language,
  setting: state.reducer.dashboard.setting,
  datos: state.reducer.flowApplicantDetail.datos,
  flowsToSend: state.reducer.flowApplicantDetail.flowsToSend,
  loading: state.reducer.flowApplicantDetail.loading,
  status: state.reducer.flowApplicantDetail.status,
  backgroundFetch: state.reducer.flowApplicantDetail.backgroundFetch,
  validateFlow: state.reducer.flowApplicantDetail.validateFlow,
  createFlow: state.reducer.flowApplicantDetail.createFlow,
  updateFlow: state.reducer.flowApplicantDetail.updateFlow,
  sendFlows: state.reducer.flowApplicantDetail.sendFlows,

  accountDriverDatos: state.reducer.accountDriver.datos,
  accountDriverStatus: state.reducer.accountDriver.status,
  accountDriverLoading: state.reducer.accountDriver.loading,

  accountVehicleDatos: state.reducer.accountVehicle.datos,
  accountVehicleStatus: state.reducer.accountVehicle.status,
  accountVehicleLoading: state.reducer.accountVehicle.loading,

  accountSemiTrailerDatos: state.reducer.accountSemiTrailer.datos,
  accountSemiTrailerStatus: state.reducer.accountSemiTrailer.status,
  accountSemiTrailerLoading: state.reducer.accountSemiTrailer.loading,
  semiTrailerExtendedProperties: state.reducer.accountSemiTrailer.extendedProperties,

  lists: state.reducer.dynamicList.lists,
});
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(flowApplicantActions, dispatch),
  accountDriverActions: bindActionCreators(accountDriverActions, dispatch),
  accountVehicleActions: bindActionCreators(accountVehicleActions, dispatch),  
  accountSemiTrailerActions: bindActionCreators(accountSemiTrailerActions, dispatch),  
  dynamicListActions: bindActionCreators(dynamicListActions, dispatch)
});
FlowApplicantDetail.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FlowApplicantDetail);



// WEBPACK FOOTER //
// ./source/client/containers/flow_applicant_detail/index.jsx